(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celucambio-product"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ccp-root]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const variantsNode = root.querySelector('[data-ccp-variants]');
      const form = root.querySelector('.ccp-form');
      if (!variantsNode || !form) return;
      const variants = JSON.parse(variantsNode.textContent);
      const variantInput = root.querySelector('[data-ccp-variant-input]');
      const optionButtons = [...root.querySelectorAll('[data-ccp-option-button]')];
      const price = root.querySelector('[data-ccp-price]');
      const addiPrice = root.querySelector('[data-ccp-addi-price]');
      const mobilePrice = root.querySelector('[data-ccp-mobile-price]');
      const compare = root.querySelector('[data-ccp-compare]');
      const saving = root.querySelector('[data-ccp-saving]');
      const discount = root.querySelector('[data-ccp-discount]');
      const monthly = root.querySelector('[data-ccp-monthly]');
      const stock = root.querySelector('[data-ccp-stock]');
      const buyNow = root.querySelector('[data-ccp-buy-now]');
      const mobileAdd = root.querySelector('[data-ccp-mobile-add]');
      const add = root.querySelector('[data-ccp-add]');
      const addLabels = [...root.querySelectorAll('[data-ccp-add-label]')];
      const buyLabel = root.querySelector('[data-ccp-buy-label]');
      const error = root.querySelector('[data-ccp-error]');
      const whatsappLinks = [...document.querySelectorAll('[data-ccp-product-whatsapp]')];
      const installments = Number(root.dataset.installments || 12);
      const storefrontLocale = root.dataset.locale || 'es-CO';
      const moneyLocale = storefrontLocale.toLowerCase() === 'es' ? 'es-CO' : storefrontLocale;
      const formatter = new Intl.NumberFormat(moneyLocale, { style: 'currency', currency: root.dataset.currency || 'COP', maximumFractionDigits: 0 });
      const formatMoney = (cents) => formatter.format(Number(cents || 0) / 100);
      const updateWhatsApp = (variant, sourceUrl) => {
        if (!whatsappLinks.length || !variant) return;
        const hasOnlyDefault = root.dataset.hasOnlyDefaultVariant === 'true';
        const template = hasOnlyDefault ? root.dataset.whatsappMessageSimple : root.dataset.whatsappMessage;
        const message = template
          .replaceAll('__PRODUCT__', root.dataset.productTitle || '')
          .replaceAll('__VARIANT__', variant.title || '')
          .replaceAll('__PRICE__', formatMoney(variant.price))
          .replaceAll('__URL__', sourceUrl);
        const href = `https://wa.me/${root.dataset.whatsappPhone}?text=${encodeURIComponent(message)}`;
        whatsappLinks.forEach((link) => { link.href = href; });
      };
      const showMedia = (mediaId) => {
        if (!mediaId) return;
        root.querySelectorAll('[data-ccp-media]').forEach((item) => { item.hidden = item.dataset.ccpMedia !== String(mediaId); });
        root.querySelectorAll('[data-ccp-thumb]').forEach((item) => {
          const active = item.dataset.ccpThumb === String(mediaId);
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
      };
      const updateVariant = (variant) => {
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = formatMoney(variant.price);
        if (addiPrice) addiPrice.textContent = formatMoney(variant.price);
        mobilePrice.textContent = formatMoney(variant.price);
        monthly.textContent = `${formatMoney(Math.ceil(variant.price / installments))}/${root.dataset.month}`;
        const hasSaving = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.classList.toggle('is-hidden', !hasSaving);
        saving.classList.toggle('is-hidden', !hasSaving);
        discount.classList.toggle('is-hidden', !hasSaving);
        if (hasSaving) {
          compare.textContent = formatMoney(variant.compare_at_price);
          saving.textContent = `${root.dataset.saving} ${formatMoney(variant.compare_at_price - variant.price)}`;
          discount.textContent = `-${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%`;
        }
        optionButtons.forEach((button) => {
          const position = Number(button.dataset.position) - 1;
          const selected = variant.options[position] === button.dataset.value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.disabled = !variants.some((candidate) => candidate.available && candidate.options[position] === button.dataset.value);
          if (selected) {
            const label = root.querySelector(`[data-ccp-option-label="${position + 1}"]`);
            if (label) label.textContent = button.dataset.value;
          }
        });
        const available = Boolean(variant.available);
        buyNow.disabled = !available;
        mobileAdd.disabled = !available;
        add.disabled = !available;
        stock.classList.toggle('is-sold-out', !available);
        stock.textContent = available ? root.dataset.available : root.dataset.soldOut;
        buyLabel.textContent = available ? root.dataset.buyNow : root.dataset.soldOut;
        addLabels.forEach((label) => { label.textContent = available ? root.dataset.addToCart : root.dataset.soldOut; });
        const mediaId = variant.featured_media?.id || variant.featured_image?.id;
        showMedia(mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        updateWhatsApp(variant, url.toString());
      };
      optionButtons.forEach((button) => button.addEventListener('click', () => {
        const position = Number(button.dataset.position) - 1;
        const selected = [];
        root.querySelectorAll('[data-ccp-option]').forEach((group) => {
          const index = Number(group.dataset.ccpOption) - 1;
          selected[index] = group.querySelector('.is-selected')?.dataset.value;
        });
        selected[position] = button.dataset.value;
        let variant = variants.find((candidate) => candidate.available && candidate.options.every((value, index) => value === selected[index]));
        if (!variant) variant = variants.find((candidate) => candidate.available && candidate.options[position] === button.dataset.value);
        if (!variant) variant = variants.find((candidate) => candidate.options[position] === button.dataset.value);
        updateVariant(variant);
      }));
      root.querySelectorAll('[data-ccp-thumb]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.ccpThumb)));
      const toast = root.querySelector('[data-ccp-toast]');
      let toastTimer;
      const showToast = (message) => {
        toast.textContent = message;
        toast.classList.add('is-visible');
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
      };
      const favorite = root.querySelector('[data-ccp-favorite]');
      const favoriteKey = `celucambio-favorite-${variantInput.value}`;
      try {
        const saved = window.localStorage.getItem(favoriteKey) === 'true';
        favorite.classList.toggle('is-active', saved);
        favorite.setAttribute('aria-pressed', String(saved));
      } catch (storageError) {}
      favorite.addEventListener('click', () => {
        const active = favorite.classList.toggle('is-active');
        favorite.setAttribute('aria-pressed', String(active));
        try { window.localStorage.setItem(favoriteKey, String(active)); } catch (storageError) {}
        showToast(active ? root.dataset.favoriteSaved : root.dataset.favoriteRemoved);
      });
      const buy = async () => {
        error.hidden = true;
        buyNow.disabled = true;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error(root.dataset.addError);
          window.location.assign('/checkout');
        } catch (requestError) {
          error.textContent = requestError.message || root.dataset.addError;
          error.hidden = false;
          buyNow.disabled = false;
        }
      };
      buyNow.addEventListener('click', buy);
      mobileAdd.addEventListener('click', () => form.requestSubmit(add));
      const mobileBar = root.querySelector('.ccp-mobile-buy');
      if (mobileBar && 'IntersectionObserver' in window) {
        let primarySeen = false;
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) primarySeen = true;
          mobileBar.classList.toggle('is-visible', primarySeen && !entry.isIntersecting);
        }, { threshold: 0.15 });
        observer.observe(add);
      }
      const dialog = root.querySelector('[data-ccp-finance-dialog]');
      root.querySelector('[data-ccp-open-finance]').addEventListener('click', () => dialog.showModal());
      root.querySelector('[data-ccp-close-finance]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["celucambio-trade-in"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cc-trade-root]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-trade-form]');
      const steps = [...root.querySelectorAll('[data-step]')];
      const progressBar = root.querySelector('[data-progress-bar]');
      const progressTrack = root.querySelector('[data-progress-track]');
      const stepLabel = root.querySelector('[data-step-label]');
      const stepName = root.querySelector('[data-step-name]');
      const actions = root.querySelector('[data-actions]');
      const backButton = root.querySelector('[data-back]');
      const nextButton = root.querySelector('[data-next]');
      const battery = root.querySelector('[data-battery]');
      const batteryValue = root.querySelector('[data-battery-value]');
      const storageOther = root.querySelector('[data-storage-other]');
      const storageOtherInput = root.querySelector('[data-storage-other-input]');
      const names = [
        root.querySelector('[data-step="1"] h2').textContent,
        root.querySelector('[data-step="2"] h2').textContent,
        root.querySelector('[data-step="3"] h2').textContent,
        root.querySelector('[data-step="4"] h2').textContent,
        root.querySelector('[data-step="5"] h2').textContent,
        root.querySelector('[data-step="6"] h2').textContent,
      ];
      let currentStep = 1;

      const selected = (name) => form.querySelector(`[name="${name}"]:checked`)?.value || '';
      const setError = (step, message) => { const node = root.querySelector(`[data-error="${step}"]`); if (node) node.textContent = message; };
      const selectCatalogProduct = (field, product) => {
        const input = field.querySelector('[data-catalog-input]');
        input.value = product.title;
        input.dataset.selectedTitle = product.title;
        input.dataset.selectedUrl = product.url || '';
        input.dataset.selectedAvailable = String(product.available);
        input.removeAttribute('aria-invalid');
        input.setAttribute('aria-expanded', 'false');
        field.querySelector('[data-catalog-results]').hidden = true;
        setError(Number(field.closest('[data-step]').dataset.step), '');
      };
      const closeResults = (field) => {
        field.querySelector('[data-catalog-results]').hidden = true;
        field.querySelector('[data-catalog-input]').setAttribute('aria-expanded', 'false');
      };
      const renderResults = (field, products) => {
        const results = field.querySelector('[data-catalog-results]');
        const availableOnly = field.dataset.mode === 'available';
        const visibleProducts = availableOnly ? products.filter((product) => product.available) : products;
        results.replaceChildren();
        if (!visibleProducts.length) {
          const empty = document.createElement('div');
          empty.className = 'cc-trade-result-status';
          empty.textContent = availableOnly ? root.dataset.noAvailable : root.dataset.noResults;
          results.append(empty);
        } else {
          visibleProducts.forEach((product, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'cc-trade-result';
            button.setAttribute('role', 'option');
            button.id = `${results.id}-option-${index}`;
            button.dataset.title = product.title;
            if (product.featured_image?.url) {
              const image = document.createElement('img');
              const imageUrl = new URL(product.featured_image.url);
              imageUrl.searchParams.set('width', '96');
              image.src = imageUrl.toString();
              image.width = 48;
              image.height = 48;
              image.loading = 'lazy';
              image.alt = '';
              button.append(image);
            } else {
              const placeholder = document.createElement('span');
              placeholder.className = 'cc-trade-result-placeholder';
              placeholder.setAttribute('aria-hidden', 'true');
              button.append(placeholder);
            }
            const copy = document.createElement('span');
            const title = document.createElement('b');
            title.textContent = product.title;
            const meta = document.createElement('small');
            const price = Number(product.price || 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
            meta.textContent = availableOnly ? `${root.dataset.available} · ${price}` : (product.available ? root.dataset.available : root.dataset.unavailable);
            copy.append(title, meta);
            button.append(copy);
            button.addEventListener('click', () => selectCatalogProduct(field, product));
            results.append(button);
          });
        }
        results.hidden = false;
        field.querySelector('[data-catalog-input]').setAttribute('aria-expanded', 'true');
      };

      const selectExactVisibleResult = (input) => {
        const normalize = (value) => value.trim().toLocaleLowerCase('es-CO');
        const query = normalize(input.value);
        const field = input.closest('[data-catalog-field]');
        const match = [...field.querySelectorAll('.cc-trade-result')].find((option) => normalize(option.dataset.title || '') === query);
        if (!match) return false;
        match.click();
        return true;
      };

      root.querySelectorAll('[data-catalog-field]').forEach((field) => {
        const input = field.querySelector('[data-catalog-input]');
        const results = field.querySelector('[data-catalog-results]');
        let timer;
        let controller;
        input.addEventListener('input', () => {
          delete input.dataset.selectedTitle;
          delete input.dataset.selectedUrl;
          input.removeAttribute('aria-invalid');
          window.clearTimeout(timer);
          const query = input.value.trim();
          if (query.length < 2) { closeResults(field); return; }
          results.replaceChildren();
          const status = document.createElement('div');
          status.className = 'cc-trade-result-status';
          status.textContent = root.dataset.searching;
          results.append(status);
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          timer = window.setTimeout(async () => {
            if (controller) controller.abort();
            controller = new AbortController();
            const base = root.dataset.searchRoot || '/';
            const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '8', 'resources[options][unavailable_products]': 'last' });
            try {
              const response = await fetch(`${base}search/suggest.json?${params}`, { signal: controller.signal, headers: { Accept: 'application/json' } });
              if (!response.ok) throw new Error('search');
              const payload = await response.json();
              renderResults(field, payload.resources?.results?.products || []);
            } catch (error) {
              if (error.name !== 'AbortError') renderResults(field, []);
            }
          }, 250);
        });
        input.addEventListener('keydown', (event) => {
          const options = [...results.querySelectorAll('[role="option"]')];
          if (!options.length) return;
          let active = options.findIndex((option) => option.classList.contains('is-active'));
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            active = event.key === 'ArrowDown' ? (active + 1) % options.length : (active <= 0 ? options.length - 1 : active - 1);
            options.forEach((option, index) => option.classList.toggle('is-active', index === active));
            input.setAttribute('aria-activedescendant', options[active].id);
          } else if (event.key === 'Enter' && active >= 0) {
            event.preventDefault();
            options[active].click();
          } else if (event.key === 'Escape') {
            closeResults(field);
          }
        });
        field.closest('[data-step]').querySelectorAll('[data-catalog-preset]').forEach((button) => button.addEventListener('click', () => selectCatalogProduct(field, { title: button.dataset.title, url: button.dataset.url, available: button.dataset.available === 'true' })));
      });
      document.addEventListener('click', (event) => root.querySelectorAll('[data-catalog-field]').forEach((field) => { if (!field.contains(event.target)) closeResults(field); }));

      const updateBattery = () => {
        const value = Number(battery.value);
        const percentage = ((value - 50) / 50) * 100;
        batteryValue.textContent = `${value}%`;
        battery.style.background = `linear-gradient(90deg,var(--cc-trade-yellow) ${percentage}%,#344064 ${percentage}%)`;
      };
      const showStep = (step) => {
        currentStep = Math.max(1, Math.min(7, step));
        steps.forEach((node) => node.classList.toggle('is-active', Number(node.dataset.step) === currentStep));
        const complete = currentStep === 7;
        actions.hidden = complete;
        stepLabel.textContent = complete ? root.dataset.completeLabel : root.dataset.stepLabel.replace('__CURRENT__', currentStep).replace('__TOTAL__', 6);
        stepName.textContent = complete ? root.dataset.readyLabel : names[currentStep - 1];
        progressBar.style.width = `${Math.min(currentStep, 6) / 6 * 100}%`;
        progressTrack.setAttribute('aria-valuenow', String(Math.min(currentStep, 6)));
        backButton.disabled = currentStep === 1;
        nextButton.textContent = currentStep === 6 ? root.dataset.review : root.dataset.continue;
        const input = steps.find((node) => Number(node.dataset.step) === currentStep)?.querySelector('input[type="search"],input[type="text"]');
        if (input) window.setTimeout(() => input.focus(), 100);
      };
      const validate = () => {
        let message = '';
        const modelInput = root.querySelector('[name="model"]');
        const desiredInput = root.querySelector('[name="desired"]');
        if (currentStep === 1 && modelInput.value.trim().length < 2) message = root.dataset.modelError;
        else if (currentStep === 1 && modelInput.dataset.selectedTitle !== modelInput.value.trim() && !selectExactVisibleResult(modelInput)) message = root.dataset.selectCatalog;
        else if (currentStep === 2 && !selected('storage')) message = root.dataset.storageError;
        else if (currentStep === 2 && selected('storage') === 'other' && storageOtherInput.value.trim().length < 2) message = root.dataset.storageOtherError;
        else if (currentStep === 4 && !selected('city')) message = root.dataset.cityError;
        else if (currentStep === 5 && !selected('invoice')) message = root.dataset.invoiceError;
        else if (currentStep === 6 && desiredInput.value.trim().length < 2) message = root.dataset.desiredError;
        else if (currentStep === 6 && desiredInput.dataset.selectedTitle !== desiredInput.value.trim() && !selectExactVisibleResult(desiredInput)) message = root.dataset.selectCatalog;
        else if (currentStep === 6 && desiredInput.dataset.selectedAvailable !== 'true') message = root.dataset.noAvailable;
        setError(currentStep, message);
        const invalidInput = currentStep === 1 ? modelInput : (currentStep === 6 ? desiredInput : null);
        if (invalidInput) {
          if (message) {
            invalidInput.setAttribute('aria-invalid', 'true');
            invalidInput.focus({ preventScroll: true });
            invalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else {
            invalidInput.removeAttribute('aria-invalid');
          }
        }
        return !message;
      };
      const formData = () => ({
        model: root.querySelector('[name="model"]').value.trim(),
        capacity: selected('storage') === 'other' ? storageOtherInput.value.trim() : selected('storage'),
        battery: `${battery.value}%`,
        city: selected('city'),
        invoice: selected('invoice'),
        desired: root.querySelector('[name="desired"]').value.trim(),
        desiredUrl: root.querySelector('[name="desired"]').dataset.selectedUrl || '',
      });
      const buildSummary = () => {
        const values = formData();
        const rows = [
          [root.dataset.summaryModel, values.model], [root.dataset.summaryStorage, values.capacity],
          [root.dataset.summaryBattery, values.battery], [root.dataset.summaryCity, values.city],
          [root.dataset.summaryInvoice, values.invoice], [root.dataset.summaryDesired, values.desired],
        ];
        const summary = root.querySelector('[data-summary]');
        summary.replaceChildren();
        rows.forEach(([label, value]) => {
          const row = document.createElement('div');
          row.className = 'cc-trade-summary-row';
          const key = document.createElement('span');
          const content = document.createElement('b');
          key.textContent = label;
          content.textContent = value;
          row.append(key, content);
          summary.append(row);
        });
        const messageRows = rows.map(([label, value], index) => `${index + 1}. ${label}: ${value}`);
        if (values.desiredUrl) messageRows.push(`${root.dataset.summaryDesired}: ${window.location.origin}${values.desiredUrl.split('?')[0]}`);
        const message = `${root.dataset.whatsappIntro}\n\n${messageRows.join('\n')}\n\n${root.dataset.whatsappSource}: ${window.location.href}`;
        root.querySelector('[data-whatsapp-button]').href = `https://wa.me/${root.dataset.whatsappPhone}?text=${encodeURIComponent(message)}`;
      };

      nextButton.addEventListener('click', () => { if (!validate()) return; if (currentStep === 6) { buildSummary(); showStep(7); return; } showStep(currentStep + 1); });
      backButton.addEventListener('click', () => showStep(currentStep - 1));
      form.addEventListener('submit', (event) => { event.preventDefault(); nextButton.click(); });
      root.querySelector('[data-edit]').addEventListener('click', () => showStep(1));
      battery.addEventListener('input', updateBattery);
      root.querySelectorAll('[name="storage"]').forEach((input) => input.addEventListener('change', () => { storageOther.classList.toggle('is-visible', selected('storage') === 'other'); setError(2, ''); }));
      root.querySelectorAll('[name="city"],[name="invoice"]').forEach((input) => input.addEventListener('change', () => setError(currentStep, '')));
      updateBattery();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
